module.exports = __webpack_public_path__ + "static/media/highlight.5c63c738.svg";